import { computeEffectiveTable, generateInvoice, legacyTimeslotsToPricingPolicies, TDR } from 'tdr-common';
import getReservationInvoice from '../api/getReservationInvoice';
import luxonToFirebaseTimestamp from './luxonToFirebaseTimestamp';
import { DateTime } from 'luxon';

export const getNewInvoiceForModifiedEpochOrGuestCount = async ({
	restaurant,
	table,
	newEpochInSeconds,
	newGuestCount,
	existingReservation,
	basePolicies
}: {
	restaurant: TDR.Restaurant;
	table: TDR.Table;
	newEpochInSeconds: number;
	newGuestCount: number;
	existingReservation: TDR.Reservation;
	basePolicies: TDR.PricingPolicy[];
}): Promise<Partial<TDR.Invoice>> => {
	const tableOverridePolicies = legacyTimeslotsToPricingPolicies(restaurant, [table]);
	const policies = [...tableOverridePolicies, ...basePolicies];
	const existingInvoice = await getReservationInvoice(existingReservation.id);

	// Booking type is per-scenario: an override can make a table request-only on one date or for one
	// party size and instant on the next. generateInvoice reads it off `tableInfo`, so resolve it for
	// the state being priced -- the NEW date and party size, which are exactly what this modification
	// is moving.
	const newDateTime = DateTime.fromSeconds(newEpochInSeconds, { zone: restaurant.timezone || 'UTC' });
	const effectiveTable = computeEffectiveTable(newDateTime, restaurant, table, { groupSize: newGuestCount });

	const newReservation: TDR.Reservation = {
		...existingReservation,
		guests: newGuestCount,
		time: luxonToFirebaseTimestamp(DateTime.fromSeconds(newEpochInSeconds))
	};

	const newInvoice = generateInvoice(
		restaurant.currency,
		policies,
		newReservation,
		existingInvoice,
		restaurant,
		existingReservation,
		effectiveTable
	);

	return newInvoice;
};
